import { useMutation } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Creates a Stripe SetupIntent for adding a new payment method to a member. */
export function useCreateSetupIntent() {
  const api = useOsApi()

  return useMutation({
    mutationFn: async (memberId: string) => {
      const response = await api.post('/members/:memberId/setup-intents', { params: { memberId } })
      if (!response.success) throw new Error(response.error.message)
      return response.data
    },
  })
}
